import {
  Component,
  OnInit,
  Input,
  Inject,
  EventEmitter,
  Output,
  SimpleChanges,
  SimpleChange,
} from '@angular/core';
import { MainService } from '../../services/main.services';
import { Role } from '../../interfaces/user';
import { ApiResult } from '../../interfaces/api-result';
import * as _ from 'lodash';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeleteConfirmDialogComponent } from '../delete-confirm-dialog/delete-confirm-dialog.component';
import { ToastProvider } from '@app/Notification/Toast/toast.provider';
@Component({
  selector: 'app-role-and-task-details',
  templateUrl: './role-and-task-details.component.html',
  styleUrls: ['./roleAndTaskDetails.scss'],
})
export class RoleAndTaskDetailsComponent implements OnInit {
  @Input() selectedRole: any;
  @Input() roleList;
  @Output() onEditRole = new EventEmitter<any>();
  @Output() onEditEntity = new EventEmitter<any>();
  @Output() onDeleteRole = new EventEmitter<any>();

  public roleEntityOperations;
  public roleEntityOperationsTotal;
  public roleEntityOperationFilter = {};

  public getSecurityEntitiesResponseList;
  public getOperationsResponseList;

  securityEnitiesAndOperationsList: any = [];

  roleEntities: any = {};
  isChecked = false;

  displayedColumns: string[] = ['EntityName', 'OperationName'];

  constructor(
    public mainService: MainService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private toastProvider: ToastProvider
  ) {}

  ngOnInit() {
    this.getRoleAndTaskEntities();
  }

  onToggle(Value, item) {
    this.roleEntities.EntityName = Value.entityName;
    this.roleEntities.OperationName = Value.operationName;
    this.roleEntities.RoleName = Value.RoleName;
    if (item.checked == true) {
      this.mainService
        .insertRoleEntityOperation(this.roleEntities)
        .subscribe((resp) => {
          this.toastProvider.sendMessage('Successfully updated.', 'success');
          // this.snackBar.open('Successfully updated.', 'OK', {
          //   duration: 2000,
          // });
          this.getRoleAndTaskEntities();
        });
    } else if (item.checked == false) {
      this.mainService
        .deleteRoleEntityOperation(this.roleEntities)
        .subscribe((resp) => {
          this.toastProvider.sendMessage('Successfully Deleted.', 'success');
          // this.snackBar.open('Successfully deleted.', 'OK', {
          //   duration: 2000,
          // });
          this.getRoleAndTaskEntities();
        });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const selectedRole: SimpleChange = changes.selectedRole;
    // console.log('prev value: ', selectedRole.previousValue);
    // console.log('got name: ', selectedRole.currentValue);
    this.selectedRole = selectedRole.currentValue
      ? selectedRole.currentValue
      : null;
    this.getRoleAndTaskEntities();
  }
  getRoleAndTaskEntities() {
    this.mainService.getRoleAndTaskDetails(this.selectedRole).subscribe(
      (res: any) => {
        if (res && res.success) {
          _.each(this.roleList, function (r) {
            var foundRole = _.find(res.response.RoleParents, function (r2) {
              return r.RoleName == r2;
            });
            r.isChecked = foundRole != null;
          });
          this.roleEntityOperations = res.response.roleAndTasks;
          _.each(this.roleEntityOperations, function (item) {
            item.RoleName = res.response.RoleName;
          });
          this.roleEntityOperations.RoleName = res.response.RoleName;
          this.roleEntityOperationsTotal = res.response.Permissions.length;
        }
      },
      (error) => {
        console.log('Error', error);
      }
    );

    this.mainService.getSecurityEntities({}).subscribe(
      (data: any) => {
        if (data && data.results && data.results.length > 0) {
          this.getSecurityEntitiesResponseList = data.results;
        } else if (data) {
          this.getSecurityEntitiesResponseList = data;
          // console.log(this.getSecurityEntitiesResponseList);
        }
      },
      (error) => {
        console.log('Error', error);
      }
    );

    this.mainService.getOperations({}).subscribe(
      (data: any) => {
        if (data) {
          this.getOperationsResponseList = data;
        } else if (data) {
          this.getOperationsResponseList = data;
          // console.log(this.getOperationsResponseList);
        }
      },
      (error) => {
        console.log('Error', error);
      }
    );
    // _.each(this.getSecurityEntitiesResponseList, function (entity) {
    //   _.each(this.getOperationsResponseList, function (operation) {
    //     var item = {
    //       EntityName: entity.EntityName,
    //       Opeartion: operation.OperationName,
    //     };
    //     this.securityEnitiesAndOperationsList.push(item);
    //     // console.log(this.securityEnitiesAndOperationsList);
    //   });
    // });

    _.each(this.getSecurityEntitiesResponseList, (entity) => {
      _.each(this.getOperationsResponseList, (operation) => {
        var item = {
          EntityName: entity.EntityName,
          Opeartion: operation.OperationName,
        };
        this.securityEnitiesAndOperationsList.push(item);
      });
    });
  }

  onEdit() {
    const editDialog = this.dialog.open(EditApplicationRoleAndTaskDialog, {
      width: '300px',
      disableClose: true,
      data: {
        role: this.selectedRole,
        roleList: this.roleList,
        roleOrg: Object.assign({}, this.selectedRole),
      },
    });

    editDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.onEditRole.emit(result);
      }
    });
  }
  onDelete() {
    const deleteDialog = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '300px',
      disableClose: true,
      data: false,
    });

    deleteDialog.afterClosed().subscribe((res) => {
      if (res) {
        this.onDeleteRole.emit(this.selectedRole);
      } else {
        // console.log("Deletion Cancelled");
      }
    });
  }

  addEntity() {
    const addEntityDialog = this.dialog.open(
      RoleAndTaskAddEntityOperationDialog,
      {
        width: '300px',
        disableClose: true,
        data: {
          securityEntities: this.getSecurityEntitiesResponseList,
          operations: this.getOperationsResponseList,
          roleOperation: {
            RoleName: this.selectedRole.RoleName,
            EntityName: '',
            OperationName: '',
          },
        },
      }
    );

    addEntityDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.onEditEntity.emit(result);
      }
    });
  }
}

@Component({
  selector: 'edit-application-role-and-task',
  templateUrl: 'role-and-task-details-edit.dialog.html',
})
export class EditApplicationRoleAndTaskDialog {
  constructor(
    public editDialog: MatDialogRef<EditApplicationRoleAndTaskDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onSubmit() {
    this.editDialog.close(this.data);
  }

  cancelEdit(): void {
    this.editDialog.close();
  }
}

@Component({
  selector: 'add-application-role-and-task',
  templateUrl: 'role-and-task-details-add.dialog.html',
})
export class AddApplicationRoleAndTaskDialog {
  constructor(
    public addDialog: MatDialogRef<AddApplicationRoleAndTaskDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onSubmit() {
    this.addDialog.close(this.data);
  }

  cancelAdd(): void {
    this.addDialog.close();
  }
}

@Component({
  selector: 'role-add-entity-operation',
  templateUrl: 'role-and-task-add-entity-operation.dialog.html',
})
export class RoleAndTaskAddEntityOperationDialog {
  constructor(
    public addDialog: MatDialogRef<RoleAndTaskAddEntityOperationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onSubmit() {
    this.addDialog.close(this.data);
  }

  cancelEdit(): void {
    this.addDialog.close();
  }
}
